




// @ is an alias to /src
import { Vue, Component } from "vue-property-decorator";
import MenuList from "@/components/menu/menuList.vue";

@Component({
  name: "MenuListPage",
  components: {MenuList},
})
export default class MenuListPage extends Vue {}
